export default "__VITE_ASSET__Co_3FPJH__"